import React from 'react';
import { motion } from 'framer-motion';
export function EliteEbooks() {
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-64">
      <div className="max-w-6xl mx-auto" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-66">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900" data-id="element-67">
            🏆 LA VERSIÓN ÉLITE INCLUYE:
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-68">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-50 border-2 border-[#F0C040] rounded-xl p-8" data-id="element-69">
            <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-70">
              01 · 📷 INTERPRETACIÓN DE IMÁGENES PARA KINESIÓLOGOS
            </h3>
            <p className="text-slate-700 mb-6 leading-relaxed" data-id="element-71">
              Aprendé a leer RX, RMN y Tomografías antes que el radiólogo.
              Identificá hernias, roturas y fracturas por imagen. Ganá la
              autoridad técnica que te diferencia de cualquier colega.
            </p>
            <ul className="space-y-2 mb-6" data-id="element-72">
              <li className="flex items-start gap-2 text-slate-700" data-id="element-73">
                <span className="text-[#F0C040] font-bold" data-id="element-74">→</span>
                <span data-id="element-75">Protocolo SINDE de lectura de imágenes</span>
              </li>
              <li className="flex items-start gap-2 text-slate-700" data-id="element-76">
                <span className="text-[#F0C040] font-bold" data-id="element-77">→</span>
                <span data-id="element-78">RX de tórax para UTI y guardia</span>
              </li>
              <li className="flex items-start gap-2 text-slate-700" data-id="element-79">
                <span className="text-[#F0C040] font-bold" data-id="element-80">→</span>
                <span data-id="element-81">RMN de columna: protrusión vs hernia</span>
              </li>
              <li className="flex items-start gap-2 text-slate-700" data-id="element-82">
                <span className="text-[#F0C040] font-bold" data-id="element-83">→</span>
                <span data-id="element-84">Rodilla, hombro, tobillo con hallazgos</span>
              </li>
              <li className="flex items-start gap-2 text-slate-700" data-id="element-85">
                <span className="text-[#F0C040] font-bold" data-id="element-86">→</span>
                <span data-id="element-87">4 casos clínicos élite resueltos</span>
              </li>
              <li className="flex items-start gap-2 text-slate-700" data-id="element-88">
                <span className="text-[#F0C040] font-bold" data-id="element-89">→</span>
                <span data-id="element-90">Cómo hablar con el médico sobre imágenes</span>
              </li>
            </ul>
            <p className="text-slate-600 font-medium" data-id="element-91">
              20 páginas A4 · Ejercicios graficados
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-50 border-2 border-[#F0C040] rounded-xl p-8" data-id="element-92">
            <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-93">
              02 · 🛡️ EL MANUAL SEGURO
            </h3>
            <p className="text-slate-600 mb-2 font-semibold" data-id="element-94">
              Protocolos para NO fallar en la Guardia y el Consultorio
            </p>
            <p className="text-slate-700 mb-6 leading-relaxed" data-id="element-95">
              Lo que la facultad olvidó enseñarte pero que protege tu matrícula,
              tu reputación y la vida del paciente.
            </p>
            <ul className="space-y-2 mb-6" data-id="element-96">
              <li className="flex items-start gap-2 text-slate-700" data-id="element-97">
                <span className="text-[#F0C040] font-bold" data-id="element-98">→</span>
                <span data-id="element-99">Las banderas rojas que NUNCA podés ignorar</span>
              </li>
              <li className="flex items-start gap-2 text-slate-700" data-id="element-100">
                <span className="text-[#F0C040] font-bold" data-id="element-101">→</span>
                <span data-id="element-102">
                  Emergencias en consultorio: síncope, hipoglucemia, crisis
                  hipertensiva
                </span>
              </li>
              <li className="flex items-start gap-2 text-slate-700" data-id="element-103">
                <span className="text-[#F0C040] font-bold" data-id="element-104">→</span>
                <span data-id="element-105">Documentación legal blindada</span>
              </li>
              <li className="flex items-start gap-2 text-slate-700" data-id="element-106">
                <span className="text-[#F0C040] font-bold" data-id="element-107">→</span>
                <span data-id="element-108">Consentimiento informado + modelo listo</span>
              </li>
              <li className="flex items-start gap-2 text-slate-700" data-id="element-109">
                <span className="text-[#F0C040] font-bold" data-id="element-110">→</span>
                <span data-id="element-111">Cómo manejar al paciente difícil</span>
              </li>
              <li className="flex items-start gap-2 text-slate-700" data-id="element-112">
                <span className="text-[#F0C040] font-bold" data-id="element-113">→</span>
                <span data-id="element-114">Los 10 errores que pueden costarte la matrícula</span>
              </li>
            </ul>
            <p className="text-slate-600 font-medium" data-id="element-115">
              20 páginas A4 · Protocolos paso a paso
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}